import { Injectable, Injector } from '@angular/core';
import { VersionInfoDto } from '@common-modules/navigation/models/version-info.dto';
import { BaseService } from '@common-modules/shared/base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { environment } from 'src/environments/environment';
import { environment } from 'projects/cloud-twin/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VersionInfoService extends BaseService {
  varsionMapping: Map<string, string> = new Map<string, string>([
    ['5.1.', '5.1.'],
    ['5.2.', '2023.1.'],
    ['5.3.', '2023.2.'],
    ['5.4.', '2023.2.1.'],
    ['5.5.', '2024.1.'],
  ]);

  versionMappingCt: Map<string, string> = new Map<string, string>([['1.0', '1.0']]);

  constructor(injector: Injector) {
    super(injector);
  }

  get endpoint() {
    return `version`;
  }

  public getVersion(): Observable<VersionInfoDto> {
    return this.get<VersionInfoDto>(this.endpoint).pipe(
      map((versions: VersionInfoDto) => {
        versions.productsVersion['1-ui'] = this.getVersionMapped(environment.version);
        versions.productsVersion['2-server'] = this.getVersionMapped(
          versions.productsVersion['2-server']
        );
        versions.productsVersion['3-database'] = this.getVersionMapped(
          versions.productsVersion['3-database']
        );

        return versions;
      })
    );
  }

  public getVersionCt(): Observable<VersionInfoDto> {
    console.log(environment);
    return this.get<VersionInfoDto>(this.endpoint).pipe(
      map((versions: VersionInfoDto) => {
        versions.productsVersion['1-ui'] = this.getVersionMappedCt(environment.version);
        versions.productsVersion['2-database'] = this.getVersionMappedCt(
          versions.productsVersion['2-database']
        );

        return versions;
      })
    );
  }

  private getVersionMapped(version: string): string {
    for (const [prefix, mappedValue] of this.varsionMapping) {
      if (version.startsWith(prefix)) {
        return version.replace(prefix, mappedValue);
      }
    }

    return version;
  }

  private getVersionMappedCt(version: string): string {
    for (const [prefix, mappedValue] of this.versionMappingCt) {
      if (version.startsWith(prefix)) {
        return version.replace(prefix, mappedValue);
      }
    }

    return version;
  }
}
